import { Building2, Gem, House as Home, Briefcase, Car, Coins, Shield, PackageOpen, Scale } from 'lucide-react';
import { Link } from "@/components/common/Link";
const giros = [{
  icon: Building2,
  name: "Notarías y corredurías públicas",
  fraccion: "Fr. X",
  slug: "/notarias",
  desc: "Escrituras, poderes, constitución de sociedades, fideicomisos. Genera expedientes por instrumento y coteja contra todas las listas obligatorias."
}, {
  icon: Gem,
  name: "Joyerías y metales preciosos",
  fraccion: "Fr. VI",
  slug: "/joyerias",
  desc: "Compraventa superior a 805 UMA. Identifica compradores, verifica origen de recursos y reporta operaciones vulnerables."
}, {
  icon: Home,
  name: "Inmobiliarias y desarrolladores",
  fraccion: "Fr. V y V Bis",
  slug: "/inmobiliarias",
  desc: "Compraventa, arrendamiento y desarrollo. Cada parte de la operación necesita su propio expediente KYC — no basta con el de la notaría."
}, {
  icon: Briefcase,
  name: "Brokers y SOFOM",
  fraccion: "Fr. IV y XIII",
  slug: "/brokers",
  desc: "Intermediación financiera e inmobiliaria. La reforma te exige tu propio proceso de identificación, independiente del de otros participantes."
}, {
  icon: Car,
  name: "Compraventa de vehículos",
  fraccion: "Fr. VII",
  slug: "/vehiculos",
  desc: "Automóviles, yates, embarcaciones y aeronaves. Umbral de identificación desde 3,210 UMA. Screening antes de entregar la unidad."
}, {
  icon: Coins,
  name: "Activos virtuales y criptomonedas",
  fraccion: "Fr. XVI",
  slug: "/activos-virtuales",
  desc: "La reforma 2025 bajó el umbral de 645 a 210 UMA. KYC a escala con API, OCR y regla de viaje."
}, {
  icon: Shield,
  name: "Blindadoras y transporte de valores",
  fraccion: "Fr. VIII y IX",
  slug: "/blindadoras",
  desc: "Blindaje de vehículos e inmuebles, traslado de efectivo. Identifica a tus clientes y reporta operaciones que superen los umbrales establecidos."
}, {
  icon: PackageOpen,
  name: "Comercio exterior y agentes aduanales",
  fraccion: "Fr. XIV",
  slug: "/comercio-exterior",
  desc: "Despacho aduanero de mercancías. KYC de importadores y exportadores, con conservación digital a 10 años."
}, {
  icon: Scale,
  name: "Mediadores, árbitros y facilitadores",
  fraccion: "Fr. XV — nueva 2025",
  slug: "/mediadores",
  desc: "La reforma 2025 te incluyó expresamente como sujeto obligado. Prepárate antes de la primera verificación."
}];
export default function SolucionesPorGiro() {
  return <section data-section-id="Featuredindustries" id="soluciones-por-giro" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl max-w-3xl">
            Para todos los sujetos obligados de la LFPIORPI
          </h2>
          <p className="mt-4 max-w-[800px] text-lg text-slate-400 font-default">
            Elige tu giro para ver cómo Notalia atiende las obligaciones específicas de tu fracción del Art. 17.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {giros.map((giro, i) => {
          const Icon = giro.icon;
          return <div key={giro.slug}>
                <div data-index={i} className="group h-full p-6 rounded-lg bg-card border border-border hover:border-primary/50 transition-all duration-200 flex flex-col">
                  <div className="flex items-center justify-between mb-4">
                    <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center">
                      <Icon className="size-6 text-primary" strokeWidth={1.5} />
                    </div>
                    <span className="text-xs font-mono uppercase tracking-wider text-primary/70">
                      {giro.fraccion}
                    </span>
                  </div>
                  <h3 className="font-default text-lg font-bold text-white mb-2 group-hover:text-primary transition-colors">
                    {giro.name}
                  </h3>
                  <p className="font-default text-sm text-slate-400 leading-relaxed flex-1">
                    {giro.desc}
                  </p>
                </div>
              </div>;
        })}
          <div>
            
          </div>
        </div>
      </div>
    </section>;
}